export const priorityViewFilterText = "MmEf7";
export const allViewFilterText = "hgtUfc";
export const priorityCalloutTitle = "Evce$d";
export const priorityCalloutDescription = "EBkQFd";
export const priorityCalloutPrimaryButtonText = "Xgv0tc";
export const priorityCalloutSecondaryButtonText = "F8qhHb";
export default {priorityViewFilterText,allViewFilterText,priorityCalloutTitle,priorityCalloutDescription,priorityCalloutPrimaryButtonText,priorityCalloutSecondaryButtonText};